import api from '@/api'

const SET_INGREDIENTS = 'SET_INGREDIENTS'
const ADD_INGREDIENT = 'ADD_INGREDIENT'
const UPDATE_INGREDIENT = 'UPDATE_INGREDIENT'

const SET_INGREDIENTS_LIST = 'SET_INGREDIENTS_LIST'

const SET_FILTERS = 'SET_FILTERS'
const RESET_FILTERS = 'RESET_FILTERS'

const SET_INGREDIENT = 'SET_INGREDIENT'
const UNSET_INGREDIENT = 'UNSET_INGREDIENT'

export default {
  namespaced: true,

  state () {
    return {
      filters: {},
      ingredients: [],
      ingredientsList: [],
      ingredient: null,
      loadDailyFeedIntakesData: null
    }
  },

  getters: {
    ingredients: (state) => state.ingredients,
    ingredientsList: (state) => state.ingredientsList,
    totalCount: (state) => state.ingredients.count || 0,
    ingredientFilters: (state) => state.filters,
    ingredient: (state) => state.ingredient,
    getDailyFeedIntakesData (state) {
      return state.loadDailyFeedIntakesData
    }
  },

  mutations: {
    [SET_INGREDIENTS] (state, data) {
      state.ingredients = data.filter((item, index) => {
        return data.findIndex(el => el.id === item.id) === index
      })
    },

    [SET_INGREDIENTS_LIST] (state, data) {
      state.ingredientsList = data
    },

    [SET_FILTERS] (state, data) {
      state.filters = data
    },

    [RESET_FILTERS] (state) {
      state.filters = {
        farm: state.filters.farm
      }
    },

    [ADD_INGREDIENT] (state, data) {
      state.ingredients.shift(data)
    },

    [UPDATE_INGREDIENT] (state, data) {
      const index = state.ingredients
        .findIndex(item => item.id === data.id)
      if (index !== -1) {
        for (const key in data) {
          state.ingredients[index][key] = data[key]
        }
      }
    },

    [SET_INGREDIENT] (state, data) {
      state.ingredient = data
    },

    [UNSET_INGREDIENT] (state) {
      state.ingredient = null
    },
    loadDailyFeedIntakes (state, payload) {
      state.loadDailyFeedIntakesData = payload
    }
  },

  actions: {
    async loadIngredients ({ commit, state }, params = {}) {
      for (const key in params) {
        state.filters[key] = params[key]
      }
      const { data, count } = await api.ingredients.list(state.filters)
      commit(SET_INGREDIENTS, data || [])
      return { data, count }
    },

    async setFilters ({ commit, dispatch }, params = {}) {
      commit(SET_FILTERS, params)
      dispatch('loadIngredients')
    },

    resetFilters ({ commit, dispatch }) {
      commit(RESET_FILTERS)
      dispatch('loadIngredients')
    },

    async createIngredient ({ dispatch }, payload) {
      const { data, errors } = await api.ingredients.create(payload)
      dispatch('loadIngredients')
      return { errors, data }
    },

    async loadIngredientsList ({ commit }, params = {}) {
      const filters = {}
      for (const key in params) {
        filters[key] = params[key]
      }
      filters.deleted = false
      const { data } = await api.ingredients.litelist(filters)
      commit(SET_INGREDIENTS_LIST, data)
      return data
    },

    getIngredientDetail (context, id) {
      return api.ingredients.getById(id)
    },

    async selectIngredient (context, id) {
      const { data } = await context.dispatch('getIngredientDetail', id)
      context.commit(SET_INGREDIENT, data)
      return data
    },

    async updateIngredient ({ commit, getters }) {
      const item = getters.ingredient
      const { data, errors } = await api.ingredients.updateById(item.id, item)
      commit(UPDATE_INGREDIENT, data)
      commit(UNSET_INGREDIENT)
      return errors
    },

    async deleteIngredient ({ commit, dispatch, getters }) {
      const item = getters.ingredient
      await api.ingredients.deleteById(item.id)
      const params = { farm: item.farm }
      dispatch('loadIngredients', params)
      commit(UNSET_INGREDIENT)
    },
    loadDailyFeedIntakesLoadData ({ commit }) {
      commit('loadDailyFeedIntakes', Math.floor(Math.random() * 100))
    },

    unsetIngredient ({ commit }) {
      commit(UNSET_INGREDIENT)
    }
  }
}
